import React from 'react';
import {Provider} from 'react-redux';
import {DownloadPublishModal} from '@Components/download-publish-modal';
import {renderElement} from '@Utils/root-element.util';
import {openPublishingOptionsModal} from '@Modals/publishing-options-modal/publishing-options-modal-library';
import {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {isUserPremium} from '@Libraries/user.library';
import {updatePublishDropDownState} from '@Components/poster-editor/poster-editor-reducer';
import {openPublishPosterModal} from '@Modals/publish-poster-modal/publish-poster-modal.library';
import {GA4EventName, trackGA4CustomEvent} from '@Libraries/ga-events';
import {PublishingOptionsList} from '@Panels/poster-publishing-options-panel/components/publishing-options-default-list/publishing-options-default-list.types';

window.PMW.mergePMW(PMW, {
  /**
   * Initiates rendering of download panel in download-publish-dialog
   *
   * @param {object} serverData
   * @param {array} serverData.productsList list of applicable products for the selected design
   * @param {array} serverData.formats List of availabe format for the selected design
   */
  renderDownloadPanel(serverData: any) {
    const containerElement = window.document.getElementById('download-publish-options');
    if (containerElement) {
      const elements = [].slice.call(containerElement.getElementsByClassName('download-section'));
      [...elements].forEach((element) => {
        renderElement(
          element,
          <Provider store={window.PMW.redux.store}>
            <DownloadPublishModal productsData={serverData.productsList} formats={serverData.formats} defaultProductId={serverData.defaultProductId} />
          </Provider>
        );
      });
    }
  },

  openPublishDialogDropDown(): void {
    window.PMW.redux.store.dispatch(updatePublishDropDownState(true));
  },

  openPublishDialog(posterHashId: string, onSuccess: () => void): void {
    openPublishingOptionsModal({
      panelDetails: {
        displayType: DisplayType.MODAL,
      },
      idPosterHash: posterHashId,
      isPosterMaker: window.PMW.isReactPosterMaker() ? 1 : 0,
      preselectPaidProduct: window.PMW.isEmbedded() && isUserPremium(),
      isPremium: window.posterEditor?.whiteboard?.getCurrentPage().isPremium() ? 1 : 0,
      posterType: window.posterEditor?.whiteboard?.type.name,
      idGalleryTemplate: window.posterEditor?.whiteboard?.idGalleryTemplate,
      idTemplate: window.posterEditor?.whiteboard?.idTemplate,
      uc: window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges() ? 1 : 0,
      isVideo: window.posterEditor?.whiteboard?.isVideo() ? 1 : 0,
      hasVideoItem: window.posterEditor?.whiteboard?.getCurrentPage().items.hasVideoItem() ? 1 : 0,
      isExpensiveVideo: window.posterEditor?.whiteboard?.getCurrentPage().isExpensiveVideo() ? 1 : 0,
      isTransparent: window.posterEditor?.whiteboard?.getCurrentPage().isTransparent() ? 1 : 0,
      hasClickableLink: window.posterEditor?.whiteboard?.getCurrentPage().items.hasClickableItem() ? 1 : 0,
      pw: window.posterEditor?.whiteboard?.width,
      ph: window.posterEditor?.whiteboard?.height,
      ptw: window.posterEditor?.whiteboard?.userWidth,
      pth: window.posterEditor?.whiteboard?.userHeight,
      ptu: window.posterEditor?.whiteboard?.units,
      onSuccessfulConfirmation: onSuccess
    });
  },

  openPublishPosterAsWebpageDialog(posterHashId: string, onSuccess: () => void): void {
    trackGA4CustomEvent(GA4EventName.PUBLISHING_MYSTUFF_WEBLINK_UNPUBLISH);
    openPublishPosterModal({
      hashedId: posterHashId,
      onTogglePublish: onSuccess,
      type: PublishingOptionsList.WEB_LINK,
    });
  },

  openPublishPosterAsQrLinkDialog(posterHashId: string, onSuccess: () => void): void {
    trackGA4CustomEvent(GA4EventName.PUBLISHING_MYSTUFF_QRLINK_UNPUBLISH);
    openPublishPosterModal({
      hashedId: posterHashId,
      onTogglePublish: onSuccess,
      type: PublishingOptionsList.QR_CODE,
    });
  },
});
